import { useEffect } from 'react';

import type {
  SourceContextScope,
  SourcePageContext,
} from '@/types/wx-copilot-context';
import { wxCopilotContextManager } from '@/utils/wx-copilot-context-manager';

export function useWxCopilotSourceContext(
  scope: SourceContextScope,
  context: SourcePageContext,
) {
  const serialized = JSON.stringify(context);
  useEffect(() => {
    wxCopilotContextManager.setSourceContext(scope, JSON.parse(serialized));
  }, [scope, serialized]);
  useEffect(() => {
    return () => wxCopilotContextManager.setSourceContext(scope, undefined);
  }, [scope]);
}
